import React, { useEffect, useState } from "react";
import DataNotFound from "../../DataNotFound/DataNotFound";
import {
  findDisplayName,
  isCreate,
  isDelete,
  isUpdate,
} from "../../../../utils/commonFunctionsAndStatices";
import { FieldTableEditAPI } from "../../../apis/apisServies";
import { useNotification } from "../../../NotificationProvider/NotificationProvider";
import { selectToken } from "../../../Store/actions/auth/authSelectors";
import { languageid } from "../../../Store/actions/languageId/selectLanguageId";
import { useSelector } from "react-redux";

const FieldTable = ({
  setActiveComponent,
  FieldData,
  setField,
  loading,
  fetchdata,
  organizationId,
  activeButton,
  checkOutCount,
  checkInCount,
  handleButtonClick
}) => {
  const { showSuccess, showError } = useNotification();
  const loginData = useSelector(selectToken);
  const languageId = useSelector(languageid);
  const [order, serOrder] = useState("");
  const [orderChange, SetOrderChange] = useState("");
  const [updating, isUpdating] = useState(false);
  const oldOrderData =
    orderChange && FieldData.find((item) => item.sort_order === orderChange);
  const handleUpdate = async (data, active, order) => {
    const dataObj = {
      user_id: loginData?.login_id,
      organization_field_id: data?.organization_field_id,
      ...((order === "delete" || order === "Recreate") && { isactive: active }),
      ...(active && {
        sort_order:
          data.display_group === "Check-in" ? ++checkInCount : ++checkOutCount,
      }),
      ...((order === "Up" || order === "Down") && {
        sort_order: order === "Up" ? data.sort_order - 1 : data.sort_order + 1,
      }),
      text_message: {
        language_id: languageId,
        ...(loginData?.organization_id
          ? { organization_id: loginData?.organization_id }
          : {}),
      },
    };
    isUpdating(true);
    const response = await FieldTableEditAPI(dataObj);
    if (response.data.statusCode === 200) {
      if (order === "delete") {
        showSuccess(response?.data?.body?.message);
        fetchdata(organizationId, activeButton);
      }
      isUpdating(false);
    } else if (response?.data?.statusCode === 409) {
      showError(response?.data?.body?.message);
    } else if (response?.data?.statusCode === 400) {
      showError(response?.data?.body?.message);
    } else {
      showError(response?.data?.body?.message);
    }
  };

  const handleOrderUpdate = async (data, order) => {
    const dataObj = {
      user_id: loginData?.login_id,
      organization_field_id: data?.organization_field_id,
      sort_order: order === "Up" ? data.sort_order + 1 : data.sort_order - 1,
      text_message: {
        language_id: languageId,
        ...(loginData?.organization_id
          ? { organization_id: loginData?.organization_id }
          : {}),
      },
    };
    isUpdating(true);
    const response = await FieldTableEditAPI(dataObj);
    if (response.data.statusCode === 200) {
      SetOrderChange("");
      serOrder("");
      showSuccess(response?.data?.body?.message);
      fetchdata(organizationId, activeButton);
      isUpdating(false);
    } else if (response?.data?.statusCode === 409) {
      showError(response?.data?.body?.message);
    } else if (response?.data?.statusCode === 400) {
      showError(response?.data?.body?.message);
    } else {
      showError(response?.data?.body?.message);
    }
  };

  useEffect(() => {
    if (oldOrderData) {
      handleOrderUpdate(oldOrderData, order);
    }
  }, [orderChange]);

  const handleEditUser = (data) => {
    setActiveComponent("update");
    setField(data);
  };
  const handleRecreate = async (data) => {
    await handleUpdate(data, true, "Recreate");
    const list =  activeButton === "inactive" ? "check-In" : activeButton;
    handleButtonClick(list);
  };
  const handleDelete = async (data) => {
    await handleUpdate(data, false, "delete");
  };
  const handleUpOrder = async (data) => {
    const id = data.sort_order - 1;
    await handleUpdate(data, "", "Up");
    SetOrderChange(id);
    serOrder("Up");
  };

  const handleDownOrder = async (data) => {
    const id = data.sort_order + 1;
    await handleUpdate(data, "", "Down");
    SetOrderChange(id);
    serOrder("Down");
  };

  let data = FieldData;
  const sortedData = [...data].sort((a, b) => a.sort_order - b.sort_order);
  if (sortedData?.length === 0 && !loading) {
    <div className="  d-flex justify-content-center align-items-center text-white h-50">
      <div className="spinner-container">
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span className="ps-2">Loading ....</span>
      </div>
    </div>;
  } else if (!sortedData || sortedData?.length === 0) {
    return <DataNotFound />;
  }

  return (
    <>
      <div className="container">
        <div className="row ps-2">
          <div className="p-2">
            <div className="table-scrol">
              <table className="table table-striped ">
                <thead className="  bg-transparent">
                  <tr>
                    <th scope="col" className="bg-transparent th-color">
                      {findDisplayName(
                        "fieldDisplayGroupHeading",
                        "Display Group"
                      )}
                    </th>

                    <th scope="col" className="bg-transparent th-color">
                      {findDisplayName("fieldFieldNameHeading", "Field Name")}
                    </th>
                    {(activeButton === "check-In" ||
                      activeButton === "check-Out") && (
                      <th scope="col" className="bg-transparent th-color">
                        {findDisplayName(
                          "fieldFieldOrderHeading",
                          "Field Order"
                        )}
                      </th>
                    )}

                    {(isDelete("isDashboardFields") ||
                      isUpdate("isDashboardFields")) && (
                      <th scope="col" className="bg-transparent th-color">
                        {findDisplayName("fieldActionHeading", "Action")}
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {sortedData?.map((item, index) => (
                    <tr key={index}>
                      <td className="bg-transparent text-white">
                        {item.display_group}
                      </td>

                      <td className="bg-transparent text-white">
                        {item.field_name}
                      </td>
                      {(activeButton === "check-In" ||
                        activeButton === "check-Out") && (
                        <td className="bg-transparent text-white">
                          <>
                            <div className="d-flex">
                              <button
                                className="rounded-circle btn btn-primary"
                                onClick={() => handleUpOrder(item)}
                                disabled={item.sort_order === 1 || updating}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-box-arrow-up"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708z"
                                  />
                                </svg>
                              </button>
                              <button
                                className="rounded-circle btn btn-primary ms-3"
                                onClick={() => handleDownOrder(item)}
                                disabled={
                                  updating ||
                                  (item.display_group === "Check-in"
                                    ? item.sort_order === checkInCount
                                    : item.sort_order === checkOutCount)
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-box-arrow-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"
                                  />
                                </svg>
                              </button>
                            </div>
                          </>
                        </td>
                      )}
                      <td className="bg-transparent text-white">
                        {(activeButton === "check-In" ||
                          activeButton === "check-Out") && (
                          <>
                            <div className="d-flex">
                              {isUpdate("isDashboardFields") && (
                                <button
                                  className="rounded-circle btn btn-primary me-3"
                                  onClick={() => handleEditUser(item)}
                                >
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1.30474 11.0182L1.77908 11.1763H1.77908L1.30474 11.0182ZM1.92906 9.14522L1.45472 8.9871L1.45472 8.9871L1.92906 9.14522ZM2.57327 8.10287L2.92682 8.45643L2.92682 8.45643L2.57327 8.10287ZM8.7948 1.88134L8.44125 1.52778L8.44125 1.52779L8.7948 1.88134ZM12.1281 5.21467L12.4817 5.56823V5.56823L12.1281 5.21467ZM5.9066 11.4362L5.55305 11.0827L5.55305 11.0827L5.9066 11.4362ZM4.86426 12.0804L5.02237 12.5548L5.02237 12.5548L4.86426 12.0804ZM2.99129 12.7047L3.1494 13.1791H3.1494L2.99129 12.7047ZM5.5649 11.7551L5.26378 11.356L5.26378 11.356L5.5649 11.7551ZM5.30234 11.9174L5.07999 11.4696L5.30234 11.9174ZM12.9311 2.80798L12.4831 3.02999V3.02999L12.9311 2.80798ZM12.9311 4.28803L12.4831 4.06603V4.06603L12.9311 4.28803ZM9.72144 1.07833L9.94345 1.52634L9.94345 1.52634L9.72144 1.07833ZM11.2015 1.07833L10.9795 1.52634V1.52634L11.2015 1.07833ZM2.09206 8.70713L2.5399 8.92949L2.5399 8.92949L2.09206 8.70713ZM2.25433 8.44458L1.85517 8.14346L1.85517 8.14346L2.25433 8.44458ZM0.994162 12.5103L0.52321 12.6782L0.994162 12.5103ZM1.49918 13.0153L1.33124 13.4863L1.33124 13.4863L1.49918 13.0153ZM8.31502 2.36115C8.11975 2.16589 7.80317 2.16589 7.60791 2.36115C7.41265 2.55641 7.41265 2.87299 7.60791 3.06825L8.31502 2.36115ZM10.9412 6.40159C11.1365 6.59685 11.4531 6.59685 11.6483 6.40159C11.8436 6.20633 11.8436 5.88974 11.6483 5.69448L10.9412 6.40159ZM1.77908 11.1763L2.40341 9.30333L1.45472 8.9871L0.8304 10.8601L1.77908 11.1763ZM2.92682 8.45643L9.14836 2.23489L8.44125 1.52779L2.21971 7.74932L2.92682 8.45643ZM11.7746 4.86112L5.55305 11.0827L6.26015 11.7898L12.4817 5.56823L11.7746 4.86112ZM4.70614 11.6061L2.83318 12.2304L3.1494 13.1791L5.02237 12.5548L4.70614 11.6061ZM5.55305 11.0827C5.3776 11.2581 5.3223 11.3118 5.26378 11.356L5.86602 12.1543C5.99287 12.0586 6.10358 11.9463 6.26016 11.7898L5.55305 11.0827ZM5.02237 12.5548C5.23244 12.4847 5.38237 12.4359 5.52469 12.3653L5.07999 11.4696C5.01433 11.5022 4.94153 11.5276 4.70614 11.6061L5.02237 12.5548ZM5.26378 11.356C5.20616 11.3995 5.14463 11.4375 5.07999 11.4696L5.52469 12.3653C5.64475 12.3056 5.75901 12.235 5.86602 12.1543L5.26378 11.356ZM11.7746 2.23489C12.2575 2.71781 12.4073 2.87697 12.4831 3.02999L13.3792 2.58597C13.2121 2.24884 12.9075 1.95362 12.4817 1.52779L11.7746 2.23489ZM12.4817 5.56823C12.9075 5.1424 13.2121 4.84718 13.3792 4.51004L12.4831 4.06603C12.4073 4.21905 12.2575 4.3782 11.7746 4.86112L12.4817 5.56823ZM12.4831 3.02999C12.6449 3.35639 12.6449 3.73962 12.4831 4.06603L13.3792 4.51004C13.6795 3.90386 13.6795 3.19216 13.3792 2.58597L12.4831 3.02999ZM9.14836 2.23489C9.63127 1.75198 9.79043 1.60217 9.94345 1.52634L9.49943 0.630321C9.1623 0.797386 8.86707 1.10196 8.44125 1.52778L9.14836 2.23489ZM12.4817 1.52779C12.0559 1.10196 11.7606 0.797386 11.4235 0.630321L10.9795 1.52634C11.1325 1.60217 11.2917 1.75197 11.7746 2.23489L12.4817 1.52779ZM9.94345 1.52634C10.2699 1.36459 10.6531 1.36459 10.9795 1.52634L11.4235 0.630322C10.8173 0.329932 10.1056 0.329932 9.49943 0.630322L9.94345 1.52634ZM2.40341 9.30333C2.48187 9.06794 2.5073 8.99514 2.5399 8.92949L1.64422 8.48478C1.57356 8.6271 1.52475 8.77703 1.45472 8.9871L2.40341 9.30333ZM2.21972 7.74932C2.06314 7.90589 1.95086 8.01661 1.85517 8.14346L2.65349 8.7457C2.69763 8.68718 2.75137 8.63187 2.92682 8.45643L2.21972 7.74932ZM2.5399 8.92949C2.57199 8.86484 2.61002 8.80331 2.65349 8.7457L1.85517 8.14346C1.77445 8.25046 1.70383 8.36473 1.64422 8.48478L2.5399 8.92949ZM0.8304 10.8601C0.697844 11.2577 0.586975 11.5888 0.524725 11.8537C0.464218 12.1112 0.424217 12.4006 0.52321 12.6782L1.46511 12.3424C1.46756 12.3492 1.44714 12.2997 1.49821 12.0824C1.54753 11.8725 1.64022 11.5929 1.77908 11.1763L0.8304 10.8601ZM2.83318 12.2304C2.4166 12.3693 2.13694 12.4619 1.92704 12.5113C1.70973 12.5623 1.66026 12.5419 1.66712 12.5444L1.33124 13.4863C1.60885 13.5853 1.8983 13.5453 2.1558 13.4847C2.42071 13.4225 2.75174 13.3116 3.1494 13.1791L2.83318 12.2304ZM0.52321 12.6782C0.657634 13.0552 0.954279 13.3518 1.33124 13.4863L1.66712 12.5444C1.57288 12.5108 1.49872 12.4366 1.46511 12.3424L0.52321 12.6782ZM7.60791 3.06825L10.9412 6.40159L11.6483 5.69448L8.31502 2.36115L7.60791 3.06825Z"
                                      fill="#091B21"
                                    />
                                  </svg>
                                </button>
                              )}
                              {isDelete("isDashboardFields") && (
                                <button
                                  className="rounded-circle btn btn-dark"
                                  onClick={() => handleDelete(item)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="20"
                                    viewBox="0 0 16 20"
                                    fill="none"
                                    className="text-center"
                                  >
                                    <path
                                      d="M6.77484 7.87549C6.77484 7.59935 6.55098 7.37549 6.27484 7.37549C5.9987 7.37549 5.77484 7.59935 5.77484 7.87549H6.77484ZM5.77484 15.8755C5.77484 16.1516 5.9987 16.3755 6.27484 16.3755C6.55098 16.3755 6.77484 16.1516 6.77484 15.8755H5.77484ZM10.7748 7.87549C10.7748 7.59935 10.551 7.37549 10.2748 7.37549C9.9987 7.37549 9.77484 7.59935 9.77484 7.87549H10.7748ZM9.77484 15.8755C9.77484 16.1516 9.9987 16.3755 10.2748 16.3755C10.551 16.3755 10.7748 16.1516 10.7748 15.8755H9.77484ZM3.36686 18.6575L3.59386 18.212L3.36686 18.6575ZM2.49283 17.7835L2.93833 17.5565H2.93833L2.49283 17.7835ZM14.0569 17.7835L13.6114 17.5565L14.0569 17.7835ZM13.1828 18.6575L12.9558 18.212H12.9558L13.1828 18.6575ZM1.27484 4.37549C0.998699 4.37549 0.774841 4.59934 0.774841 4.87549C0.774841 5.15163 0.998699 5.37549 1.27484 5.37549V4.37549ZM15.2748 5.37549C15.551 5.37549 15.7748 5.15163 15.7748 4.87549C15.7748 4.59934 15.551 4.37549 15.2748 4.37549V5.37549ZM4.27484 4.87549C4.27484 5.15163 4.4987 5.37549 4.77484 5.37549C5.05098 5.37549 5.27484 5.15163 5.27484 4.87549H4.27484ZM11.2748 4.87549C11.2748 5.15163 11.4987 5.37549 11.7748 5.37549C12.051 5.37549 12.2748 5.15163 12.2748 4.87549H11.2748ZM5.77484 7.87549V15.8755H6.77484V7.87549H5.77484ZM9.77484 7.87549V15.8755H10.7748V7.87549H9.77484ZM13.7748 4.87549V15.6755H14.7748V4.87549H13.7748ZM11.0748 18.3755H5.47484V19.3755H11.0748V18.3755ZM1.77484 4.87549V15.6755H2.77484V4.87549H1.77484ZM5.47484 18.3755C4.90654 18.3755 4.51038 18.3751 4.20196 18.3499C3.89938 18.3252 3.72553 18.2791 3.59386 18.212L3.13987 19.103C3.43601 19.2539 3.7561 19.3168 4.12053 19.3466C4.47912 19.3759 4.92304 19.3755 5.47484 19.3755V18.3755ZM1.77484 15.6755C1.77484 16.2273 1.77445 16.6712 1.80375 17.0298C1.83353 17.3942 1.89643 17.7143 2.04733 18.0105L2.93833 17.5565C2.87124 17.4248 2.82515 17.251 2.80043 16.9484C2.77523 16.6399 2.77484 16.2438 2.77484 15.6755H1.77484ZM3.59386 18.212C3.31161 18.0682 3.08214 17.8387 2.93833 17.5565L2.04732 18.0105C2.28701 18.4809 2.66946 18.8633 3.13987 19.103L3.59386 18.212ZM13.7748 15.6755C13.7748 16.2438 13.7745 16.6399 13.7493 16.9484C13.7245 17.251 13.6784 17.4248 13.6114 17.5565L14.5024 18.0105C14.6533 17.7143 14.7162 17.3942 14.7459 17.0298C14.7752 16.6712 14.7748 16.2273 14.7748 15.6755H13.7748ZM11.0748 19.3755C11.6266 19.3755 12.0706 19.3759 12.4292 19.3466C12.7936 19.3168 13.1137 19.2539 13.4098 19.103L12.9558 18.212C12.8241 18.2791 12.6503 18.3252 12.3477 18.3499C12.0393 18.3751 11.6431 18.3755 11.0748 18.3755V19.3755ZM13.6114 17.5565C13.4675 17.8387 13.2381 18.0682 12.9558 18.212L13.4098 19.103C13.8802 18.8633 14.2627 18.4809 14.5024 18.0105L13.6114 17.5565ZM1.27484 5.37549H2.27484V4.37549H1.27484V5.37549ZM2.27484 5.37549H14.2748V4.37549H2.27484V5.37549ZM14.2748 5.37549H15.2748V4.37549H14.2748V5.37549ZM5.27484 4.07549C5.27484 2.62555 6.57487 1.37549 8.27484 1.37549V0.375488C6.10882 0.375488 4.27484 1.99081 4.27484 4.07549H5.27484ZM8.27484 1.37549C9.97481 1.37549 11.2748 2.62555 11.2748 4.07549H12.2748C12.2748 1.99081 10.4409 0.375488 8.27484 0.375488V1.37549ZM4.27484 4.07549V4.87549H5.27484V4.07549H4.27484ZM11.2748 4.07549V4.87549H12.2748V4.07549H11.2748Z"
                                      fill="#FF6060"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </>
                        )}
                        {activeButton === "inactive" && (
                          <div className="d-flex">
                            {isCreate("isDashboardFields") && (
                              <button
                                className="rounded-circle btn btn-primary me-3"
                                onClick={() => handleRecreate(item)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="13"
                                  viewBox="0 0 17 13"
                                  fill="none"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.1102 0.534434C14.3845 0.262508 14.7548 0.10947 15.1411 0.108404C15.5273 0.107338 15.8985 0.258331 16.1743 0.52874C16.4501 0.799148 16.6084 1.16724 16.615 1.55345C16.6216 1.93965 16.4759 2.31292 16.2095 2.59258L8.38463 12.3736C8.25015 12.5185 8.08784 12.6347 7.9074 12.7154C7.72697 12.7961 7.53211 12.8396 7.33449 12.8432C7.13687 12.8469 6.94054 12.8107 6.75725 12.7367C6.57395 12.6628 6.40744 12.5526 6.26769 12.4128L1.08313 7.22633C0.938699 7.09174 0.822851 6.92944 0.742501 6.74911C0.662151 6.56878 0.618946 6.37411 0.615463 6.17672C0.61198 5.97933 0.648292 5.78326 0.72223 5.60021C0.796168 5.41716 0.906219 5.25087 1.04582 5.11127C1.18542 4.97167 1.3517 4.86162 1.53475 4.78768C1.71781 4.71375 1.91388 4.67743 2.11127 4.68092C2.30866 4.6844 2.50333 4.72761 2.68366 4.80796C2.86399 4.88831 3.02629 5.00415 3.16088 5.14859L7.2654 9.25115L14.0729 0.577558C14.0851 0.562374 14.0982 0.547971 14.1121 0.534434H14.1102Z"
                                    fill="#091B21"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldTable;
